const ROLES = {
  Autoridad: 'Autoridad',
  Administrador: 'Administrador',
  Responsable: 'Gestor',
};

const ESTADO = {
  Abierta: 'ABIERTA',
  En_proceso: 'ENPROCESO',
  Pendiente: 'PENDIENTERESPUESTA',
  Finalizada: 'FINALIZADA',
  Desestimada: 'DESESTIMADA',
  Enviada: 'ENVIADA',
};

export { ROLES, ESTADO };
